import StepWindFacilityData from '../../FacilityData/StepWindFacilityData';
import WHO_TILE_CONFIGS from './tileConfigs/StepWho.config';
import PRODUCT_TILE_CONFIGS from './tileConfigs/StepWhichProduct.config';
import FACILITY_TYPE_TILE_CONFIGS from './tileConfigs/StepFacilityType.config';
import CERTIFICATE_TILE_CONFIGS from './tileConfigs/StepCertificate.config';
import LARGE_SOLAR_FACILITY_TYPE_TILE_CONFIGS from './tileConfigs/StepLargeSolarFacilityType.config';
import POWER_TYPE_TILE_CONFIGS from './tileConfigs/StepPowerType.config';
import StepGenericTile from '../steps/StepGenericTile';
import StepSomeInformation from '../steps/StepSomeInformation';
import StepIndividualOffer from '../steps/StepIndividualOffer';
import StepWaterFacilityData from '../../FacilityData/StepWaterFacilityData';
import StepSolarFacilityData from '../../FacilityData/StepSolarFacilityData';
import StepBioMasseFacilityData from '../../FacilityData/StepBioMasseFacilityData';
import StepCo2Form from '../../CertificateForm/StepCo2Form';
import StepProofOfOriginForm from '../../CertificateForm/StepProofOfOriginForm';
import StepLargeSolarFacilityData from '../steps/StepLargeSolarFacilityData';
import StepGreenPowerData from '../../PowerDelivery/StepGreenPowerData';
import StepGreyPowerData from '../../PowerDelivery/StepGreyPowerData';
import StepBusinessChargingData from '../steps/StepBusinessChargingData';
import BUSINESS_CUSTOMER_PRODUCT_TILE_CONFIGS from './tileConfigs/StepWhichBusinessCustomerProduct.config';
import StepImmoChargingData from '../steps/StepImmoChargingData';
import StepCoopChargingData from '../steps/StepCoopChargingData';
import { mapTileConfigIndex, type WizardNode } from '../types/wizardTypes';

export const LAST_TWO_STEPS: WizardNode[] = [
  {
    componentClass: StepSomeInformation,
    fieldName: 'information',
    stepIndicatorLabel: 'stepindicator.label.information',
    noMapNeeded: true,
    props: {},
    urlValue: 'Angaben',
    nodes: [
      {
        componentClass: StepIndividualOffer,
        stepIndicatorLabel: 'stepindicator.label.individualOffer',
        props: {},
        urlValue: 'Zusammenfassung',
      },
    ],
  },
];

export const WIZARD_STRUCTURE: WizardNode = {
  componentClass: StepGenericTile,
  fieldName: 'category',
  stepIndicatorLabel: 'stepindicator.label.category',
  props: {
    name: 'category',
    msgId: 'offerWizard.stepWho.title',
    introMsgId: 'offerWizard.stepWho.intro',
    tileConfigs: WHO_TILE_CONFIGS,
  },
  map: {
    gewerbekunde: 0,
    energieversorger: 1,
    industriekunde: 1,
    anlagenbetreiber: 1,
  },
  noMapNeeded: false,
  urlValue: 'Kategorie',
  nodes: [
    {
      componentClass: StepGenericTile,
      fieldName: 'product',
      stepIndicatorLabel: 'stepindicator.label.product',
      props: {
        name: 'product',
        msgId: 'offerWizard.stepWhichBusinessCustomerProduct.title',
        tileConfigs: BUSINESS_CUSTOMER_PRODUCT_TILE_CONFIGS,
      },
      map: BUSINESS_CUSTOMER_PRODUCT_TILE_CONFIGS.reduce(
        mapTileConfigIndex,
        {}
      ),
      noMapNeeded: false,
      urlValue: 'Produkt',
      nodes: [
        {
          componentClass: null,
          skipThisStep: true,
          noMapNeeded: true,
          props: {},
          nodes: [
            {
              componentClass: StepImmoChargingData,
              fieldName: 'immoChargingData',
              stepIndicatorLabel: 'stepindicator.label.immoChargingData',
              noMapNeeded: true,
              props: {},
              nodes: LAST_TWO_STEPS,
            },
          ],
        },
        {
          componentClass: null,
          skipThisStep: true,
          noMapNeeded: true,
          props: {},
          nodes: [
            {
              componentClass: StepCoopChargingData,
              fieldName: 'coopChargingData',
              stepIndicatorLabel: 'stepindicator.label.coopChargingData',
              noMapNeeded: true,
              props: {},
              nodes: LAST_TWO_STEPS,
            },
          ],
        },
      ],
    },
    {
      componentClass: StepGenericTile,
      fieldName: 'product',
      stepIndicatorLabel: 'stepindicator.label.product',
      props: {
        name: 'product',
        msgId: 'offerWizard.stepWhichProduct.title',
        tileConfigs: PRODUCT_TILE_CONFIGS,
      },
      map: PRODUCT_TILE_CONFIGS.reduce(mapTileConfigIndex, {}),
      noMapNeeded: false,
      urlValue: 'Produkt',
      nodes: [
        {
          componentClass: StepGenericTile,
          fieldName: 'powerType',
          stepIndicatorLabel: 'stepindicator.label.powerType',
          props: {
            name: 'powerType',
            msgId: 'offerWizard.stepPowerType.title',
            tileConfigs: POWER_TYPE_TILE_CONFIGS,
          },
          map: POWER_TYPE_TILE_CONFIGS.reduce(mapTileConfigIndex, {}),
          noMapNeeded: false,
          urlValue: 'Stromart',
          nodes: [
            {
              componentClass: StepGreenPowerData,
              fieldName: 'greenPowerData',
              stepIndicatorLabel: 'stepindicator.label.greenPowerData',
              noMapNeeded: true,
              props: {},
              urlValue: 'Oekostrom',
              nodes: LAST_TWO_STEPS,
            },
            {
              componentClass: StepGreyPowerData,
              fieldName: 'greyPowerData',
              stepIndicatorLabel: 'stepindicator.label.greyPowerData',
              noMapNeeded: true,
              props: {},
              urlValue: 'GrauerStrom',
              nodes: LAST_TWO_STEPS,
            },
          ],
        },
        {
          componentClass: StepGenericTile,
          fieldName: 'certificate',
          stepIndicatorLabel: 'stepindicator.label.certificate',
          props: {
            name: 'certificate',
            msgId: 'offerWizard.StepCertificate.title',
            tileConfigs: CERTIFICATE_TILE_CONFIGS,
          },
          map: CERTIFICATE_TILE_CONFIGS.reduce(mapTileConfigIndex, {}),
          noMapNeeded: false,
          urlValue: 'Zertifikat',
          nodes: [
            {
              componentClass: StepCo2Form,
              fieldName: 'co2CertificateData',
              stepIndicatorLabel: 'stepindicator.label.co2CertificateData',
              noMapNeeded: true,
              props: {},
              urlValue: 'CO2',
              nodes: LAST_TWO_STEPS,
            },
            {
              componentClass: StepProofOfOriginForm,
              fieldName: 'proofOfOriginCertificateData',
              stepIndicatorLabel:
                'stepindicator.label.proofOfOriginCertificateData',
              noMapNeeded: true,
              props: {},
              urlValue: 'Herkunftsnachweis',
              nodes: LAST_TWO_STEPS,
            },
          ],
        },
        {
          componentClass: StepGenericTile,
          fieldName: 'facilityType',
          stepIndicatorLabel: 'stepindicator.label.facilityType',
          props: {
            name: 'facilityType',
            msgId: 'offerWizard.stepFacilityType.title',
            tileConfigs: FACILITY_TYPE_TILE_CONFIGS,
          },
          map: FACILITY_TYPE_TILE_CONFIGS.reduce(mapTileConfigIndex, {}),
          noMapNeeded: false,
          urlValue: 'Anlagentyp',
          nodes: [
            {
              componentClass: StepWindFacilityData,
              fieldName: 'windFacilityData',
              stepIndicatorLabel: 'stepindicator.label.windFacilityData',
              noMapNeeded: true,
              props: {},
              urlValue: 'Wind',
              nodes: LAST_TWO_STEPS,
            },
            {
              componentClass: StepWaterFacilityData,
              fieldName: 'waterFacilityData',
              stepIndicatorLabel: 'stepindicator.label.waterFacilityData',
              noMapNeeded: true,
              props: {},
              urlValue: 'Wasser',
              nodes: LAST_TWO_STEPS,
            },
            {
              componentClass: StepSolarFacilityData,
              fieldName: 'solarFacilityData',
              stepIndicatorLabel: 'stepindicator.label.solarFacilityData',
              noMapNeeded: true,
              props: {},
              urlValue: 'Solar',
              nodes: LAST_TWO_STEPS,
            },
            {
              componentClass: StepBioMasseFacilityData,
              fieldName: 'bioMasseFacilityData',
              stepIndicatorLabel: 'stepindicator.label.bioMasseFacilityData',
              noMapNeeded: true,
              props: {},
              urlValue: 'Biomasse',
              nodes: LAST_TWO_STEPS,
            },
          ],
        },
        {
          componentClass: StepGenericTile,
          fieldName: 'largeSolarFacilityType',
          stepIndicatorLabel: 'stepindicator.label.largeSolarFacilityType',
          props: {
            name: 'largeSolarFacilityType',
            msgId: 'offerWizard.stepLargeSolarFacility.title.desktop',
            mobileHeaderMsgId:
              'offerWizard.stepLargeSolarFacility.title.mobile',
            tileConfigs: LARGE_SOLAR_FACILITY_TYPE_TILE_CONFIGS,
          },
          map: LARGE_SOLAR_FACILITY_TYPE_TILE_CONFIGS.reduce(
            mapTileConfigIndex,
            {}
          ),
          noMapNeeded: true,
          urlValue: 'Anlagentyp',
          nodes: [
            {
              componentClass: StepLargeSolarFacilityData,
              fieldName: 'largeSolarFacilityData',
              stepIndicatorLabel: 'stepindicator.label.largeSolarFacilityData',
              noMapNeeded: true,
              props: {},
              urlValue: 'Anlagendaten',
              nodes: LAST_TWO_STEPS,
            },
          ],
        },
        {
          componentClass: null,
          skipThisStep: true,
          noMapNeeded: true,
          props: {},
          nodes: [
            {
              componentClass: StepBusinessChargingData,
              fieldName: 'businessChargingData',
              stepIndicatorLabel: 'stepindicator.label.businessChargingData',
              noMapNeeded: true,
              props: {},
              nodes: LAST_TWO_STEPS,
            },
          ],
        },
      ],
    },
  ],
};
